import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getPromotionDetail } from '../../services'
import { DashboardKeys } from '@/modules/dashboard/keys'
import {
	GetPromotionDetailResponse,
	GetPromotionDetailRequest,
} from '@/modules/dashboard/type'

export default function useQueryGetPromotionDetail(
	payload: GetPromotionDetailRequest,
	props?: UseBaseQueryOptions<GetPromotionDetailResponse>,
) {
	return useQuery({
		queryKey: [DashboardKeys.PromotionDetail, payload],
		queryFn: () => getPromotionDetail(payload),
		...props,
	})
}
